import {
  formatBigNumber, handleNotAvailable, parseDateTime, providerFor,
} from "./utils";

class Share {
  constructor() {
    this.apiBase = "https://md8jnn29kj.execute-api.eu-west-1.amazonaws.com/live";
    this.data = null;
  }

  getTradingDetails() {
    return new Promise((resolve) => {
      if (this.data) resolve(this.data);

      window.addEventListener("share-details-loaded", () => {
        resolve(this.data);
      });
    });
  }

  loadTradingDetails() {
    const url = `${this.apiBase}/details`;
    return fetch(url)
      .then((res) => res.json())
      .then((td) => {
        const currentSession = td.instr?.currInstrSess;
        const dayPerformance = td.instr?.perf?.find((p) => p.perType === "D");

        this.data = {
          openTime: currentSession?.openDtTm,
          openPrice: parseFloat(currentSession?.openPx),
          updatedAt: currentSession?.dateTime,
          lastPrice: parseFloat(currentSession?.lastPx),
          marketCapitalisation: parseFloat(
            currentSession?.marketCapitalisation,
          ),
          volume: parseFloat(currentSession?.tradedQty),
          vwap: parseFloat(currentSession?.vwap), // vwap: Volume Weighted Average Price
          previousClosePrice: parseFloat(currentSession?.prevAdjClosingPrice),
          highestPrice: parseFloat(dayPerformance?.highPx),
          highestPriceAt: dayPerformance?.highPxDtTm,
          lowestPrice: parseFloat(dayPerformance?.lowPx),
          lowestPriceAt: dayPerformance?.lowPxDtTm,
          priceChangeSincePreviousClose: parseFloat(dayPerformance?.var),
          priceDiffSincePreviousClose: parseFloat(dayPerformance?.pxVar),
        };

        return this.data;
      });
  }

  getHistoricalPrices() {
    const url = `${this.apiBase}/history`;
    return fetch(url).then((res) => res.json());
  }

  getIntradayPrices() {
    const url = `${this.apiBase}/intraday`;
    return fetch(url).then((res) => res.json());
  }

  getPriceData() {
    return this.loadTradingDetails().then((td) => {
      const priceChange = td.lastPrice - (td.previousClosePrice || td.lastPrice);
      const percentChange = (td.lastPrice / (td.previousClosePrice || td.lastPrice) - 1) * 100;
      const timeFormat = "h:mm:ss A";

      return {
        sessionTime: parseDateTime(td.updatedAt).format("LLL"),
        lastPrice: handleNotAvailable(td.lastPrice.toFixed(2)),
        priceChange: handleNotAvailable(priceChange.toFixed(2)),
        percentChange: handleNotAvailable(percentChange.toFixed(2)),
        previousClosePrice: handleNotAvailable(td.previousClosePrice.toFixed(2)),
        tradedVolume: handleNotAvailable(td.volume),
        volumeAmount: formatBigNumber(td.volume * td.vwap),
        openPrice: handleNotAvailable(td.openPrice),
        openAt: parseDateTime(td.openTime).format(timeFormat),
        lowestPrice: handleNotAvailable(td.lowestPrice),
        lowestAt: parseDateTime(td.lowestPriceAt).format(timeFormat),
        highestPrice: handleNotAvailable(td.highestPrice),
        highestAt: parseDateTime(td.highestPriceAt).format(timeFormat),
      };
    });
  }
}

export default providerFor(() => new Share());
